import React, { useEffect, useRef, useState } from 'react';
import ROLogo from 'images/realty-one-group-color-large.png';

const INITIAL_STEP = 1;

export default function ListMyHomeModal({
  data,
  closeModal,
  current_user,
  areas,
}) {
  const modalRef = useRef();

  // Modal State
  const [step, setStep] = useState(INITIAL_STEP);
  // Form State
  const [formState, setFormState] = useState({});
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (formState) {
      Object.entries(formState).forEach(([key, val]) => {
        const elementType = key === 'area' ? 'select' : 'input';
        const inputSelector = document.querySelector(
          `#seller-form .inquiry_${key} ${elementType}`
        );
        inputSelector.value = val;
      });
    }
  }, [formState]);

  const handleInput = e => {
    if (errors[e.target.name]) {
      const errorsCopy = { ...errors };
      delete errorsCopy[e.target.name];
      setErrors(errorsCopy);
    }

    setFormState({ ...formState, [e.target.name]: e.target.value });
  };

  const handleSubmit = e => {
    e.preventDefault();

    const { first_name, last_name, email, phone, address, message } = formState;

    let tempErrors = {};
    // Validation
    if (!first_name) tempErrors = { ...tempErrors, first_name: true };
    if (!last_name) tempErrors = { ...tempErrors, last_name: true };
    if (!email) tempErrors = { ...tempErrors, email: true };
    if (!phone) tempErrors = { ...tempErrors, phone: true };
    if (!address) tempErrors = { ...tempErrors, address: true };
    if (!message) tempErrors = { ...tempErrors, message: true };

    if (Object.keys(tempErrors).length) {
      setErrors(tempErrors);
    } else {
      // eslint-disable-next-line no-lonely-if
      document.querySelector('form#seller-form #inquiry_submit').click();

      setStep(2);
    }
  };

  const hideForm = () => {
    closeModal();
  };

  const clearForm = () => {
    setStep(INITIAL_STEP);
    setFormState({});
  };

  return (
    <aside id="mls-inquiry-modal" ref={modalRef} className="modal-container">
      <div className="modal-backdrop" />

      <div className="modal mls-inquiry">
        <img data-src={ROLogo} alt="" className="mls-form-image lazyload" />

        {/* Step 1: General vs Tour select */}
        {step === 1 && (
          <form className="mls-form-container" onSubmit={handleSubmit}>
            <h3 className="form-title">Ready to list your home?</h3>
            <p className="form-subtitle">
              Our trusted partner agents are eager to assist you in the selling
              process. Fill out your info below and an agent will reach out to
              you as soon as possible.
            </p>

            <fieldset>
              <div
                className={`input ${
                  errors.first_name ? 'field_with_errors' : ''
                }`}
              >
                <label htmlFor="first_name" className="input">
                  First name*
                </label>
                <input
                  type="first_name"
                  id="first_name"
                  name="first_name"
                  placeholder="Enter your first name"
                  value={formState.first_name}
                  onChange={handleInput}
                />
                {errors.first_name && (
                  <span className="error">First name can't be blank</span>
                )}
              </div>

              <div
                className={`input ${
                  errors.last_name ? 'field_with_errors' : ''
                }`}
              >
                <label htmlFor="last_name" className="input">
                  Last name*
                </label>
                <input
                  type="last_name"
                  id="last_name"
                  name="last_name"
                  placeholder="Enter your last name"
                  value={formState.last_name}
                  onChange={handleInput}
                />
                {errors.last_name && (
                  <span className="error">Last name can't be blank</span>
                )}
              </div>

              <div
                className={`input ${errors.email ? 'field_with_errors' : ''}`}
              >
                <label htmlFor="email" className="input">
                  Email address*
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Enter your email address"
                  value={formState.email}
                  onChange={handleInput}
                />
                {errors.email && (
                  <span className="error">Email can't be blank</span>
                )}
              </div>

              <div
                className={`input ${errors.phone ? 'field_with_errors' : ''}`}
              >
                <label htmlFor="phone" className="input">
                  Phone number*
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  placeholder="Enter your phone number"
                  value={formState.phone}
                  onChange={handleInput}
                />
                {errors.phone && (
                  <span className="error">Phone number can't be blank</span>
                )}
              </div>

              <div
                className={`input ${errors.area ? 'field_with_errors' : ''}`}
              >
                <label htmlFor="area" className="input">
                  Area*
                </label>
                <select
                  id="area"
                  name="area"
                  className="areas-select"
                  value={formState.area}
                  required
                  onChange={handleInput}
                >
                  <option value="">Select an area</option>
                  {areas.map(area => (
                    <option key={area.id} value={area.id}>
                      {area.name}
                    </option>
                  ))}
                </select>
              </div>

              <div
                className={`input ${errors.address ? 'field_with_errors' : ''}`}
              >
                <label htmlFor="address" className="input">
                  Address*
                </label>
                <input
                  type="address"
                  id="address"
                  name="address"
                  placeholder="Enter your address"
                  value={formState.address}
                  onChange={handleInput}
                />
                {errors.address && (
                  <span className="error">Address can't be blank</span>
                )}
              </div>

              <div
                className={`input ${errors.message ? 'field_with_errors' : ''}`}
              >
                <label htmlFor="message" className="input">
                  Message*
                </label>
                <textarea
                  // type="textarea"
                  id="message"
                  name="message"
                  placeholder="Enter your message"
                  value={formState.message}
                  onChange={handleInput}
                />
                {errors.message && (
                  <span className="error">Message can't be blank</span>
                )}
              </div>
            </fieldset>

            <div className="form-actions-container">
              <button
                type="submit"
                aria-label="Submit"
                title="Submit"
                className="btn btn--blue-grad"
              >
                Submit
              </button>
              <button
                type="button"
                aria-label="Cancel"
                title="Cancel"
                className="btn btn--link"
                onClick={() => {
                  clearForm();
                  hideForm();
                  // TODO: Refactor. See Note in ListMyHome.js
                  document.querySelector(
                    '.mls-show-page-container'
                  ).style.height = 'auto';
                }}
              >
                Cancel
              </button>
            </div>

            {!current_user?.id && (
              <p className="modal-notice">
                We noticed you aren’t logged in or might not have an account
                yet. By submitting this inquiry, you agree to having a temporary
                account created using the above information if one doesn’t exist
                already.
              </p>
            )}
          </form>
        )}

        {/* Step 2: Success Message */}
        {step === 2 && (
          <section className="mls-form-container">
            <h3 className="form-title">Your inquiry has been submitted!</h3>
            <p className="form-subtitle">
              Thank you for your message! An agent will reach out to you as soon
              as possible.
            </p>

            {!current_user?.id && (
              <p className="form-subtitle">
                A temporary account has been created for you. Please check your
                email to complete the sign up process.
              </p>
            )}

            <div className="form-actions-container">
              <button
                type="submit"
                aria-label="Submit"
                title="Submit"
                className="btn btn--blue-grad"
                onClick={() => {
                  hideForm();
                }}
              >
                Close
              </button>
            </div>
          </section>
        )}
      </div>
    </aside>
  );
}
